import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Novo Tenant", -1)
const _hoisted_3 = { class: "table is-fullwidth" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " ID "),
    /*#__PURE__*/_createElementVNode("th", null, " Tenant ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_router_link, {
      to: "/dashboard/tenant/novo",
      class: "button"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenants, (tenant) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: tenant.id
          }, [
            _createElementVNode("td", null, _toDisplayString(tenant.id), 1),
            _createElementVNode("td", null, _toDisplayString(tenant.name), 1)
          ]))
        }), 128))
      ])
    ]),
    (_ctx.tenants)
      ? (_openBlock(), _createBlock(_component_Table, {
          key: 0,
          options: _ctx.tenants
        }, null, 8, ["options"]))
      : _createCommentVNode("", true)
  ]))
}